
import * as $ from 'jquery';

import * as AllyConfig from 'src/shared/rest/Config';

/**
 * The Blackboard Learn LMS
 *
 * @class
 * @implements {ExampleInterface}
 */
export function LearnRestApi() {}

/**
 * @see ExampleInterface.prototype.sign
 */
LearnRestApi.prototype.sign = function(method, path, parameters, callback) {
    var data = {
        'url': AllyConfig.baseUrl() + path,
        'headers': {
            'Authorization': `Bearer ${ this._getJwtToken()}`
        },
        'parameters': parameters
    };
    return callback(null, data);
};

/**
 * @see ExampleInterface.prototype.http
 */
LearnRestApi.prototype.http = function(method, path, parameters, opts, callback) {
    opts = opts || {};

    var req = {
        'url': AllyConfig.baseUrl() + path,
        'type': method,
        'crossDomain': true,
        'xhrFields': {
            'withCredentials': false
        },
        'data': parameters,
        'success': function(data) {
            return callback(null, data);
        },
        'error': function(xhr, code) {
            return callback({ 'code': code, 'msg': xhr.responseText });
        }
    };
    req.headers = opts.headers || {};
    req.headers.Authorization = `Bearer ${ this._getJwtToken()}`;

    if (opts.contentType) {
        req.contentType = opts.contentType;
    }

    $.ajax(req);
};

/**
 * @see ExampleInterface.prototype.getDownloadUrl
 */
LearnRestApi.prototype.getDownloadUrl = function(fileId, callback) {
    // At this point it's unclear whether a file can be downloaded when only the fileId is known
    return callback({ 'code': 501, 'msg': 'Learn does not support direct downloads' });
};

LearnRestApi.prototype._getJwtToken = function() {
    return window.ALLY_TOKEN;
};
